<!--
  @TimelineHandle  Small handle on the left side of the timeline (bar) to extract or retract it.
  The triangle points in the direction the timeline moves when clicking.
-->

<script>
		import {view} from "../client.svelte.js";
</script>


<button class="timeline-handle" class:extended={view.timelineShown} data-help="timeline"
        title={view.timelineShown ? "Timeline einklappen" : "Timeline ausklappen"}
        aria-label={view.timelineShown ? "Timeline einklappen" : "Timeline ausklappen"}
        onclick={() => view.timelineShown = !view.timelineShown}>
	<span class="triangle"></span>
</button>


<style lang="sass">
	.timeline-handle
		position: absolute
		left: -14px
		top: 50%
		transform: translateY(-50%)
		z-index: 1
		width: 14px
		height: 48px
		margin: 0
		padding: 0
		border: 0
		border-radius: 6px 0 0 6px
		background: #c6b492
		display: grid
		place-items: center
		cursor: pointer
		opacity: 0.85

		&:hover
			opacity: 1

	/* triangle pointing left (extract) or right (retract) */
	.triangle
		width: 0
		height: 0
		border-block: 6px solid transparent
		border-right: 7px solid #3a2f1d

	.extended .triangle
		border-right: 0
		border-left: 7px solid #3a2f1d
</style>
